module.exports = __webpack_public_path__ + "static/media/ic_snapshot_close.39de0e28.svg";